import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";

const LinkText = styled.span`
  ${tw`underline cursor-pointer`}
`;

const Overlay = styled.div`
  ${tw`fixed inset-0 flex items-center justify-center`}
  background: rgba(0,0,0,0.35);
  z-index: 1000;
`;

const Popup = styled.div`
  ${tw`relative bg-white rounded-2xl shadow-2xl`}
  max-width: 420px;
  width: 90%;
  padding: 1.5rem;
`;

const CloseButton = styled.button`
  ${tw`absolute text-gray-500 hover:text-black`}
  top: 0.5rem;
  right: 0.6rem;
  font-size: 1.4rem;
  line-height: 1;
`;

export default function InlineHint({ text, description }) {
  const [open, setOpen] = useState(false);

  if (!text || !description) return null;

  return (
    <>
      <LinkText onClick={() => setOpen(true)}>
        {text}
      </LinkText>

      {open && (
        <Overlay onClick={() => setOpen(false)}>
          <Popup onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setOpen(false)}>
              ×
            </CloseButton>

            <div
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Popup>
        </Overlay>
      )}
    </>
  );
}